// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Z2Ba","fixed":"Loader_fixed__2UHT0","alignTop":"Loader_alignTop__2eqCC","backdrop":"Loader_backdrop__24rs4","img":"Loader_img__2kGFj"};